module.exports = __webpack_public_path__ + "static/media/peoples.ccd86ede.jpg";